export default {"src":"/_next/static/media/luggage-free-dark.def07c80.svg","height":40,"width":190,"blurWidth":0,"blurHeight":0};